import { useManagerProfile } from '../../../../../../../../prodivers/managerProfile';

type NavigationPagesParams = {
    portfolioId: number | string;
    dfsClientId: number | string;
    t: (key: string) => string;
    showDeposits?: boolean;
    showDetails?: boolean;
    showStrategy?: boolean;
    showCases?: boolean;
};

export const navigationPages = ({
    portfolioId, dfsClientId, t, showDeposits, showDetails, showStrategy, showCases,
}: NavigationPagesParams) => {
    const { hasAccessPolicy } = useManagerProfile();
    const pages = [
        {
            title: t('clients.portfolioNav.overview'),
            path: `/client/${dfsClientId}/portfolios/${portfolioId}/tab/overview`,
            pathnameKey: '/overview',
        },
        {
            title: t('clients.portfolioNav.strategy'),
            path: `/client/${dfsClientId}/portfolios/${portfolioId}/tab/strategy`,
            pathnameKey: '/strategy',
            hidden: () => !showStrategy,
        },
        {
            title: t('clients.portfolioNav.inventory'),
            path: `/client/${dfsClientId}/portfolios/${portfolioId}/tab/stock`,
            pathnameKey: '/stock',
        },
        {
            title: t('clients.portfolioNav.payIn'),
            path: `/client/${dfsClientId}/portfolios/${portfolioId}/tab/deposit`,
            pathnameKey: '/deposit',
            hidden: () => !showDeposits,
        },
        {
            title: t('navigation.topNav.kudi'),
            path: `/client/${dfsClientId}/portfolios/${portfolioId}/tab/details`,
            pathnameKey: '/details',
            hidden: () => !(hasAccessPolicy('ShadowAccounts') && showDetails),
        },
        {
            title: t('navigation.topNav.cases'),
            path: `/client/${dfsClientId}/portfolios/${portfolioId}/tab/cases`,
            pathnameKey: '/cases',
            hidden: () => !showCases,
        },
    ];

    return pages;
};
